"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountType = void 0;
var DiscountType;
(function (DiscountType) {
    DiscountType[DiscountType["TravelAgent"] = 0] = "TravelAgent";
    DiscountType[DiscountType["ApiPartner"] = 1] = "ApiPartner";
    DiscountType[DiscountType["DiscountCode"] = 2] = "DiscountCode";
    DiscountType[DiscountType["Manual"] = 3] = "Manual";
    DiscountType[DiscountType["FirstOrder"] = 4] = "FirstOrder";
})(DiscountType || (exports.DiscountType = DiscountType = {}));
//# sourceMappingURL=DiscountType.js.map